import { useContext } from "react";
import { useStore } from "zustand";

import { InferenceFormContext } from "./context";
import { InferenceFormState } from "./store";

export const useInferenceFormStore: {
  (): InferenceFormState;
  <T>(selector: (state: InferenceFormState) => T): T;
  <T>(selector?: (state: InferenceFormState) => T): T | InferenceFormState;
} = <T,>(
  selector?: (state: InferenceFormState) => T,
): T | InferenceFormState => {
  const store = useContext(InferenceFormContext);
  if (!store)
    throw new Error("Missing InferenceFormContext.Provider in the tree");
  // When selector is undefined, useStore returns the full state
  return useStore(store, selector as any);
};
